module.exports = __webpack_public_path__ + "static/media/ic_small_save_white.0b4878fa.svg";